import * as localForage from 'localforage'
import * as t from 'io-ts'
import { Future } from 'funfix'
import { Option } from 'fp-ts/lib/Option'
import { option } from 'fp-ts'
import { Void } from 'src/framework'

export interface LocalStorageIF {
  retrieve<T>(token: string, decoder: t.Decoder<unknown, T>): Future<Option<T>>
  store<T>(token: string, value: T, encoder: t.Encoder<T, unknown>): Future<void>
  removeItem(key: string): Future<void>
  clear(): Future<void>
}

export class LocalStorageService implements LocalStorageIF {
  retrieve = <T>(token: string, decoder: t.Decoder<unknown, T>): Future<Option<T>> =>
    Future.fromPromise(localForage.getItem(token)).map(value => option.fromEither(decoder.decode(value)))

  store = <T>(token: string, value: T, encoder: t.Encoder<T, unknown>): Future<void> =>
    Future.fromPromise(localForage.setItem(token, encoder.encode(value))).map(_ => Void)

  removeItem = (key: string): Future<void> => Future.fromPromise(localForage.removeItem(key))

  clear = (): Future<void> => Future.fromPromise(localForage.clear())
}



// WEBPACK FOOTER //
// ./src/services/local-storage.ts